/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/no-extraneous-dependencies
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useCreateWorkLoad = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) =>
      client(`fixed/services/add`, {
        data,
        successMessage: "Workload added successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetWorkLoadRequests"] });
    },
  });
};

export const useGetWorkLoadRequests = (data: any) =>
  useQuery({
    queryKey: [
      "GetWorkLoadRequests",
      data?.pageNumber,
      data?.pageRowCount,
      data?.searchCriteria,
      data?.cashCenterId,
      data?.customerId,
      data?.locationBarcode,
      data?.dayOfWeek,
      data?.isActive,
    ],
    queryFn: () => client(`fixed/services`, { data }),
  });

export const useUpdateWorkLoadStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`fixed/services/update/service/status`, {
        data,
        // successMessage: "Service status updated successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetWorkLoadRequests"] });
    },
  });
};

export const useGetWorkLoadFixedServices = (data: any) => {
  return useQuery({
    queryKey: [
      "Fixed Services",
      data?.cashCenterId,
      data?.customerId,
      data?.serviceType,
      data?.periodType,
      data?.dayOfWeek,
      data?.dateOfMonth,
    ],
    queryFn: () =>
      client(`fixed/services/list`, {
        data,
      }),
    enabled:
      Boolean(data?.cashCenterId) &&
      Boolean(data?.customerId) &&
      Boolean(data?.serviceType) &&
      Boolean(data?.periodType) &&
      Boolean(data?.dayOfWeek || data?.dateOfMonth),
  });
};

export const useCreateWorkLoadService = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`fixed/services/create/services`, {
        data,
        successMessage: "Workload created successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetWorkLoadRequests"] });
    },
  });
};
